import { ModalService } from 'src/app/core/services/utils/modal.service';
import { EmitService } from './../../../../core/services/utils/emit.service';
import { Component, OnInit } from '@angular/core';
import { fromEvent, Observable, Subscription } from 'rxjs';

@Component({
  selector: 'app-modal-offline',
  templateUrl: './modal-offline.component.html',
  styleUrls: ['./modal-offline.component.css']
})
export class ModalOfflineComponent implements OnInit {
  viene: any;
  onlineEvent!: Observable<Event>;
  offlineEvent!: Observable<Event>;
  subscriptions: Subscription[] = [];
  connectionStatus: string = 'offline';

  constructor(
    private emit: EmitService,
    private modalService: ModalService
  ) { }

  ngOnInit(): void {
    /**
    * Get the online/offline status from browser window
    */
    this.onlineEvent = fromEvent(window, 'online');
    this.offlineEvent = fromEvent(window, 'offline');

    this.subscriptions.push(this.onlineEvent.subscribe(e => {
      this.connectionStatus = 'online';
      this.closeModal();
      switch (this.viene) {
        case 'sesion':
          this.emit.enviarData('sesion');
          break;
        case 'continuar':
          this.emit.enviarData('continuar');
          break;
        case 'iniciar':
          this.emit.enviarData('iniciar');
          break;
        case 'terminarTurno':
          this.emit.enviarData('terminarTurno');
          break;
        case 'cerrar':
          this.emit.enviarData('cerrar');
          break;
        case 'motivos':
          this.emit.enviarData('motivos');
          break;
          case 'enviarMotivos':
            //this.emit.enviarData('motivos');
            break;
      }
    }));

    this.subscriptions.push(this.offlineEvent.subscribe(e => {
      this.connectionStatus = 'offline';
    }));
  }

  closeModal(): void {
    this.modalService.closeModal();
  }

}
